export default {
  default: () => import("/home/runner/work/grove-web/grove-web/layouts/default.vue").then(m => m.default || m),
  embedded: () => import("/home/runner/work/grove-web/grove-web/layouts/embedded.vue").then(m => m.default || m)
}